module.exports = __webpack_public_path__ + "img/Electronics, Smart Home & Appliances.ba1b555f.png";